import utils from 'utils'
import Invoice from '../../fillOpenManage/invoice1/standModel/Invoice'
import Customer from '../../fillOpenManage/invoice1/standModel/Customer'
import { globalFn } from '../../fillOpenManage/invoice1/invoiceUtils'
import * as config from './urbanConfiguration'

export default class fullElectricInvoiceEditCtrl {
    constructor($scope, httpRequest, $state, $stateParams, $http, logger, buyerChecker, globalFn, $uibModal) {
        $scope.isAdd = $state.current.name.indexOf('add') > -1 ? true : false
        $scope.isRealEstate = $state.current.name.indexOf('realEstateDetail') > -1 ? true : false //是否为特定发票 - 不动产租赁服务
        $scope.isConstruction = $state.current.name.indexOf('constructionDetail') > -1 ? true : false //是否为特定发票 - 建筑服务
        $scope.isWorkspace = $state.current.name.indexOf('fullEleInvoiceDetail') > -1 ? true : false
        // $scope.isTaxplayerType = JSON.parse(localStorage.user_info).sale.taxplayerType == 2 ? true : false //是否为小规模纳税人
        if ($scope.invoice && $scope.invoice.customer) {
            $scope.$watch('invoice.customer.custCreditCode', () => {
                $scope.invoice.customer.custCreditCode = $scope.invoice.customer.custCreditCode && $scope.invoice.customer.custCreditCode.toUpperCase()
            })
        }
        $scope.totalInvoice = 1
        $scope.currentInvoice = 1
        $scope.invoiceId = $stateParams.invoiceId
        $scope.invType = $stateParams.invType
        // 隐藏一二级菜单
        if ($stateParams.detailFlag === true) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        $scope.ukeyList = $scope.userInfo.tax4UkeyList
        /**
         * 获取是否开启审批流
         */
        httpRequest
            .post_qryFlowIsValid({
                approveCode: 'tax4_opened_invoice_approve',
            })
            .then((res) => {
                // 开启审批流
                $scope.isFlowOpened = res.data.value
            })
        /**
         * 初始化发票对象
         * @return {scope}
         */
        async function makeInvoice() {
            $scope.invoice = new Invoice()
            if ($scope.invoiceId) {
                $scope.isEdit = true
                const detailParam = {
                    invoiceId: $scope.invoiceId,
                    needRel: true,
                }
                utils.loading('正在加载数据，请耐心等待......')
                let getListApi = 'post_tax4OrdinaryGetOne'
                if ($stateParams.invType == '62') {
                    getListApi = 'post_tax4SpecialGetOne'
                }
                const _res = await httpRequest[getListApi](detailParam)
                let invoiceData = _res.data.value.header
                $scope.invType = invoiceData.invType
                invoiceData.businessBaseDTO = _res.data.value.businessBase
                invoiceData.detail = _res.data.value.lines
                invoiceData.sale = _res.data.value.header
                invoiceData.customer = _res.data.value.header
                invoiceData.invoiceKinshipList = _res.data.value.invoiceKinshipList
                $scope.invoice = new Invoice(invoiceData)
                $scope.invoice.freightTransportDetailList = _res.data.value.freightTransportDetailList
                $scope.invoice.extend = _res.data.value.extend
                formatSpecificData()
                utils.loaded()
                $scope.$apply()
            } else {
                $scope.invTypeChangeSelAble = true
                $scope.invoice = new Invoice()
                const waitIdRes = await httpRequest.get_getSnowFlakeId()
                $scope.invoice.invoiceId = waitIdRes.data.value
                $scope.invoice.invType = $stateParams.invType
                $scope.invoice.ukey = {
                    ukeyId: $scope.ukeyList[0].ukeyId,
                    openPeople: $scope.ukeyList[0].defaultDrawer,
                    ukeyCode: $scope.ukeyList[0].ukeyCode,
                    invoiceOrgId: $scope.ukeyList[0].orgId,
                }
                $scope.invoice.extend = {
                    authorizeId: $scope.ukeyList[0].authorizeId,
                    differenceTax: '',
                    isBalance: '',
                }
                $scope.invoice.freightTransportDetailList = []
                if ($state.current.name.indexOf('red') >= 0) {
                    $scope.invoice.$isRed = '1'
                    $scope.invoice.redReason = '1'
                    $scope.invTypeChangeSelAble = false
                }
            }
            //特定发票 详情页面展示值改造
            if ($scope.isRealEstate) {
                //房屋产权证书/不动产权证号 certificateOfTitle
                //面积单位 unitOfArea
                //不动产地址 administrativeRegion + fullAddress
                //租赁期起止 leaseTermStart leaseTermEnd
                //跨地（市）标志 transRegionalFlag
                //自定义备注
                let realEstateSpecific = JSON.parse($scope.invoice.extend.realEstateSpecific)
                $scope.invoice.details[0].certificateOfTitle = realEstateSpecific.certificateOfTitle
                $scope.invoice.details[0].unitOfArea = realEstateSpecific.unitOfArea
                realEstateSpecific.transRegionalFlag = realEstateSpecific.transRegionalFlag == 'N' ? '否' : '是'
                let showRemark = $scope.invoice.remark ? $scope.invoice.remark : ''
                $scope.showRemark = '不动产地址：' + realEstateSpecific.administrativeRegion + realEstateSpecific.fullAddress + '      租赁期起止：' + realEstateSpecific.leaseTermStart + ' ' + realEstateSpecific.leaseTermEnd + '      跨地（市）标志：' + realEstateSpecific.transRegionalFlag + '\n' + showRemark
            }
            //特定发票 详情页面展示值改造
            if ($scope.isConstruction) {
                // 建筑服务发生地字段拼接显示 建筑服务发生地+发生地详细地址
                // 建筑服务发生地 site
                // 发生地详细地址 siteDetailedAddress
                // 建筑项目名称 constructionProjectName
                // 土地增值税项目编号+跨地（市）标志+自定义备注
                // 土地增值税项目编号 landItemNumber
                // 跨地（市）标志  transRegionalFlag N：否；Y：是
                let realEstateSpecific = JSON.parse($scope.invoice.extend.realEstateSpecific)
                let siteDetailedAddress = realEstateSpecific.siteDetailedAddress ? realEstateSpecific.siteDetailedAddress : ''
                $scope.invoice.details[0].siteDetailedAddress = realEstateSpecific.site + siteDetailedAddress
                $scope.invoice.details[0].constructionProjectName = realEstateSpecific.constructionProjectName ? realEstateSpecific.constructionProjectName : ''
                realEstateSpecific.transRegionalFlag = realEstateSpecific.transRegionalFlag == 'N' ? '否' : '是'
                let showRemark = $scope.invoice.remark ? $scope.invoice.remark : ''
                let showLandItemNumber = realEstateSpecific.landItemNumber ? realEstateSpecific.landItemNumber : ''
                $scope.showRemark = '土地增值税项目编号：' + showLandItemNumber + '      跨地（市）标志：' + realEstateSpecific.transRegionalFlag + '\n' + showRemark
            }
        }
        setTimeout(() => {
            $('#blue-inv-date').datetimepicker({
                autoclose: true,
                minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                language: 'zh-CN',
                format: 'yyyy-mm-dd',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
            })
        }, 200)
        $scope.init = async function init() {
            makeInvoice()
            const typecodeArr = ['zero_tax', 'inv_type', 'ovat_red_reason', 'red_blue_invoice_type', 'open_reason_tax4', 'tax4_difference_tax', 'red_confirm_red_reason', 'preferential_code', 'specific_element']
            $scope.dictionary = {}
            const disctDataRes = await httpRequest.get_dictByTypeArr(JSON.stringify(typecodeArr))
            Object.assign($scope.dictionary, disctDataRes.data.value)
        }
        $scope.transferTypeList = [
            {
                enumCode: '铁路运输',
                enumName: '铁路运输',
            },
            {
                enumCode: '公路运输',
                enumName: '公路运输',
            },
            {
                enumCode: '水路运输',
                enumName: '水路运输',
            },
            {
                enumCode: '航空运输',
                enumName: '航空运输',
            },
            {
                enumCode: '管道运输',
                enumName: '管道运输',
            },
        ]
        $scope.trans_regional_flag = [
            {
                enumCode: 'Y',
                enumName: '是',
            },
            {
                enumCode: 'N',
                enumName: '否',
            },
        ]
        $scope.unit_area = [
            {
                enumCode: '平方千米',
                enumName: '平方千米',
            },
            {
                enumCode: '平方米',
                enumName: '平方米',
            },
            {
                enumCode: '公顷',
                enumName: '公顷',
            },
            {
                enumCode: '亩',
                enumName: '亩',
            },
            {
                enumCode: 'hm²',
                enumName: 'hm²',
            },
            {
                enumCode: 'km²',
                enumName: 'km²',
            },
            {
                enumCode: 'm²',
                enumName: 'm²',
            },
        ]
        $scope.init()
        $scope.selectedRows = []
        $scope.createTime = new Date()
        // TODO1 采用新的控件
        $scope.qryCustNameList = function qryCustNameList($item) {
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, $item).then((response) =>
                response.data.value.map((item) =>
                    $.extend(
                        {},
                        {
                            custCodeAndcustName: `${item.customerName} ${item.creditCode}`,
                        },
                        item
                    )
                )
            )
        }
        $scope.selectCust = function selectCust($item) {
            $scope.invoice.customer = new Customer().fromCustomer($item)
        }

        // TODO1 采用新的控件 end
        $scope.copyInvoice = function copyInvoice(item) {
            // 清空ID 和多余数据
            if (item.extend) {
                item.extend.extendId = ''
                item.extend.invoiceId = ''
            }
            item.lines.forEach((i) => {
                i.id = ''
                i.invoiceId = ''
            })
            $scope.selectedRows = []
            item.header.invoiceId = $scope.invoice.invoiceId
            item.header.kplsh = ''

            let header = item.header
            let lines = item.lines
            let businessBase = item.businessBase
            let invoiceKinshipList = item.invoiceKinshipList
            let extend = item.extend

            let invoiceData = {
                adValoremTotal: header.adValoremTotal,
                applicant: header.applicant,
                applyDate: header.applyDate,
                blueElectricInvoiceNum: header.blueElectricInvoiceNum,
                createTime: header.createTime,
                createUser: header.createUser,
                creditType: header.creditType,
                custCode: header.custCode,
                custCreditCode: header.custCreditCode,
                custEmail: header.custEmail,
                custMobile: header.custMobile,
                custName: header.custName,
                electricInvoiceNum: header.electricInvoiceNum,
                expirationTime: header.expirationTime,
                invSubType: header.invSubType,
                invType: header.invType,
                invoiceCode: header.invoiceCode,
                invoiceDate: header.invoiceDate,
                invoiceId: header.invoiceId,
                invoiceNumber: header.invoiceNumber,
                invoiceOrgId: header.invoiceOrgId,
                invoiceResultDesc: header.invoiceResultDesc,
                invoiceStatus: header.invoiceStatus,
                isLock: header.isLock,
                isRed: header.isRed,
                isTax: header.isTax,
                kplsh: header.kplsh,
                lockTime: header.lockTime,
                manager: header.manager,
                openPeople: header.openPeople,
                openReason: header.openReason,
                openStatus: header.openStatus,
                redAmount: header.redAmount,
                redInformId: header.redInformId,
                redInformNo: header.redInformNo,
                redReason: header.redReason,
                redTax: header.redTax,
                remark: header.remark,
                restoreFailMessage: header.restoreFailMessage,
                saleCreditCode: header.saleCreditCode,
                saleId: header.saleId,
                saleName: header.saleName,
                tax4CustAddress: header.tax4CustAddress,
                tax4CustBank: header.tax4CustBank,
                tax4CustBankAccount: header.tax4CustBankAccount,
                tax4CustPhone: header.tax4CustPhone,
                tax4SaleAddress: header.tax4SaleAddress,
                tax4SaleBank: header.tax4SaleBank,
                tax4SaleBankAccount: header.tax4SaleBankAccount,
                tax4SalePhone: header.tax4SalePhone,
                totalAmt: header.totalAmt,
                totalTaxamt: header.totalTaxamt,
                ukeyCode: header.ukeyCode,
                ukeyId: header.ukeyId,
                updateTime: header.updateTime,
                updateUser: header.updateUser,
                waitInvoiceStatus: header.waitInvoiceStatus,
                invoiceSource: 1,
                businessBaseDTO: businessBase,
                detail: lines,
                sale: header,
                customer: header,
                extend: extend,
                invoiceKinshipList: invoiceKinshipList,
            }
            $scope.invoice = new Invoice(invoiceData)
            $scope.invoice.ukey.ukeyId = item.header.ukeyId
            formatSpecificData()
        }

        $scope.copyFromBlue = function copyFromBlue(item) {
            $scope.blueInvoice = item
            $scope.invoice.fromBlue(item)
            $scope.invoice.blueInvoiceDate = item.invoiceDate.substring(0, 10)
            $scope.invoice.blueInvoiceType = item.invType
            $scope.newList = item.invoiceDetailList
        }

        // 选择开票点
        $scope.changerUkeyId = function changerUkeyId() {
            const newUkeyListArr = $scope.ukeyList.filter((item) => item.ukeyId === $scope.invoice.ukey.ukeyId)
            $scope.invoice.ukey.openPeople = newUkeyListArr[0].defaultDrawer // 开票人
            $scope.invoice.ukey.authorizeId = newUkeyListArr[0].authorizeId // 税局授权账户ID
            $scope.invoice.ukey.ukeyCode = newUkeyListArr[0].ukeyCode
            $scope.invoice.ukey.invoiceOrgId = newUkeyListArr[0].orgId
        }

        $scope.goListPage = function goListPage() {
            $state.go('outputManage.fullElectricInvoice.fullEleInvoice.list')
        }
        $scope.filterUkeyName = function filterUkeyName(id) {
            const fliterUkeyNameArr = $scope.ukeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }
        $scope.submit = function submit(type) {
            if (!checkData()) return
            if ($scope.invoice.businessBaseDTO) {
                $scope.invoice.businessBaseDTO.needSave = true //业务信息 需要储存
            }
            let getScratchApi = 'post_tax4OrdinaryManuallyAdd' // 暂存
            let getBatchSubmitApi = 'post_tax4OrdinaryBatchSubmit' //提交
            let getSubmitApi = 'post_tax4OrdinaryInvoice' //开票
            if ($stateParams.invType == '62') {
                getScratchApi = 'post_tax4SpecialManuallyAdd'
                getBatchSubmitApi = 'post_tax4SpecialBatchSubmit'
                getSubmitApi = 'post_tax4SpecialInvoice'
            }
            if ($scope.tax4InvoiceData) {
                $scope.invoice.invoiceDetailKinshipList = $scope.tax4InvoiceData.invoiceDetailKinshipList
                $scope.invoice.invoiceKinshipList = $scope.tax4InvoiceData.invoiceKinshipList
                $scope.invoice.precastInvoiceDetailKinshipList = $scope.tax4InvoiceData.precastInvoiceDetailKinshipList
                $scope.invoice.businessBaseDTO = $scope.tax4InvoiceData.businessBase
            }
            if ($scope.invoice.custName) {
                delete $scope.invoice.custName
                delete $scope.invoice.creditType
                delete $scope.invoice.custAddress
                delete $scope.invoice.custBank
                delete $scope.invoice.custBankAccount
                delete $scope.invoice.custCode
                delete $scope.invoice.custCreditCode
                delete $scope.invoice.custEmail
                delete $scope.invoice.custMobile
                delete $scope.invoice.custName
                delete $scope.invoice.custPhone
                delete $scope.invoice.tax4CustAddress
                delete $scope.invoice.tax4CustBank
                delete $scope.invoice.tax4CustBankAccount
                delete $scope.invoice.tax4CustPhone
            }
            submitFormatSpecificData()
            buyerChecker.checkBuyerCreditCode($scope.invoice.customer.custCreditCode, $scope.invoice.customer.creditType, $scope.invoice.invType).then(() => {
                httpRequest[getScratchApi]($scope.invoice.toTax4WaitDTO()).then(
                    (res) => {
                        $scope.tax4InvoiceData = res.data.value
                        $scope.tax4InvoiceData.lines.forEach((item, index) => {
                            $scope.invoice.details[index].id = item.id
                            $scope.invoice.details[index].invoiceId = item.invoiceId
                        })
                        $scope.invoice.extend.extendId = $scope.tax4InvoiceData.extend.extendId
                        $scope.invoice.extend.invoiceId = $scope.tax4InvoiceData.extend.invoiceId
                        $scope.invoice.extend.authorizeId = $scope.tax4InvoiceData.extend.authorizeId
                        if (type === 1) {
                            logger.logSuccess('暂存成功')
                        } else {
                            let invoiceIds = []
                            invoiceIds.push($scope.invoice.invoiceId)
                            httpRequest[getBatchSubmitApi]({ invoiceIds: invoiceIds }).then((res) => {
                                if (res.data.value.error > 0) {
                                    logger.logError(res.data.value.messageList[0].errorMsg)
                                } else if ($scope.isFlowOpened) {
                                    logger.logSuccess('提交成功')
                                    setTimeout(() => {
                                        $scope.goListPage()
                                    }, 1000)
                                } else {
                                    realSubmit(getSubmitApi)
                                }
                            })
                        }
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            })
        }
        // 最后提交流程
        let realSubmit = function (getSubmitApi) {
            utils.loaded()
            const btns = ['开票', '取消']
            window.layer.open({
                title: '操作提醒',
                content: '提交成功,是否继续开票，您也可以稍后在列表页面开票',
                btn: btns,
                yes(index) {
                    httpRequest[getSubmitApi]($scope.invoice.invoiceId).then(
                        (res) => {
                            logger.logSuccess('提交成功')
                            window.layer.close(index)
                            setTimeout(() => {
                                $scope.goListPage()
                            }, 1000)
                        },
                        (error) => {
                            console.log(error)
                            logger.logError(error.data.message)
                            $scope.goListPage()
                        }
                    )
                },
                btn2(index) {
                    window.layer.close(index)
                    $scope.goListPage()
                },
                cancel(index) {
                    window.layer.close(index)
                    $scope.goListPage()
                },
            })
        }
        function checkOpenReason() {
            //小规模纳税人 存在开票商品税率为3%或1%时，<开具理由>如为空，提交后取默认值0
            const isTaxRateArr = $scope.invoice.details.filter((item) => item.taxRate == 0.03 || item.taxRate == 0.01)
            let isSysParam = false
            httpRequest.get_openReasonSysParam().then((res) => {
                isSysParam = res.data.value
                if ($scope.isTaxplayerType && isTaxRateArr.length > 0 && isSysParam && ($scope.invoice.invType == '2' || $scope.invoice.invType == '51')) {
                    $scope.invoice.openReason = $scope.invoice.openReason ? $scope.invoice.openReason : 0
                } else {
                    $scope.invoice.openReason = null
                }
            })
        }
        // 校验
        function checkData() {
            if ($scope.invoice.differenceTax) {
                const newDetails = $scope.invoice.details.filter((item) => item.lineNature == '0')
                if (newDetails.length > 1) {
                    logger.logError('差额发票不能超过一行以上的普通商品行!')
                    return false
                }
            }
            if ($scope.invoice.remark && $scope.invoice.remark.toString().length > 200) {
                logger.logError('备注超长，字段长度限制为200字符以内，请修改备注后重新提交开票')
                return false
            }
            if ($scope.invoice.businessBaseDTO && $scope.invoice.businessBaseDTO.projectName && $scope.invoice.businessBaseDTO.projectName.toString().length > 100) {
                logger.logError('项目名称超长，字段长度限制为100字符以内，请修改项目名称后重新提交开票')
                return false
            }
            /* if ($scope.invoice.customer.tax4CustPhone && !utils.regExpTest($scope.invoice.customer.tax4CustPhone, 'phone')) {
                logger.logError('电话格式不正确')
                return false
            }
            if ($scope.invoice.customer.tax4CustBankAccount && !utils.regExpTest($scope.invoice.customer.tax4CustBankAccount, 'bankCard')) {
                logger.logError('银行账号格式不正确')
                return false
            }*/
            if ($scope.invoice.adValoremTotal < 0) {
                logger.logError('正数发票合计金额必须大于0')
                return false
            }
            if ($scope.invoice.customer.custName && $scope.invoice.customer.custName.toString().length > 100) {
                logger.logError('购方名称超长，字段长度限制在100字符以内')
                return false
            }
            if ($scope.invoice.customer.custCreditCode && $scope.invoice.customer.custCreditCode.toString().length > 20) {
                logger.logError('购方税号超长，字段长度限制在20字符以内')
                return false
            }
            if ($scope.invoice.customer.tax4CustBank && $scope.invoice.customer.tax4CustBank.toString().length > 100) {
                logger.logError('购方开户行超长，字段长度限制在100字符以内')
                return false
            }
            if ($scope.invoice.customer.tax4CustBankAccount && $scope.invoice.customer.tax4CustBankAccount.toString().length > 50) {
                logger.logError('购方银行账号超长，字段长度限制在50字符以内')
                return false
            }
            if ($scope.invoice.customer.tax4CustAddress && $scope.invoice.customer.tax4CustAddress.toString().length > 100) {
                logger.logError('购方地址超长，字段长度限制在100字符以内')
                return false
            }
            if ($scope.invoice.customer.tax4CustPhone && $scope.invoice.customer.tax4CustPhone.toString().length > 20) {
                logger.logError('购方电话超长，字段长度限制在20字符以内')
                return false
            }
            if ($scope.invoice.extend.specificElements === '04') {
                if (!$scope.invoice.freightTransportDetailList.length) {
                    logger.logError('特定要素信息不能为空')
                    return false
                }
                for (let index = 0; index < $scope.invoice.freightTransportDetailList.length; index++) {
                    const element = $scope.invoice.freightTransportDetailList[index]
                    element.serialNo = index + 1
                    if (!element.transferType) {
                        logger.logError('运输工具种类不能为空')
                        return false
                    }
                    if (!element.transferToolLicensePlate) {
                        logger.logError('运输工具号牌不能为空')
                        return false
                    }
                    if (!element.placeOfOrigin) {
                        logger.logError('起运地不能为空')
                        return false
                    }
                    if (!element.placeOfDestination) {
                        logger.logError('到达地不能为空')
                        return false
                    }
                    if (!element.goodsName) {
                        logger.logError('运输货物名称不能为空')
                        return false
                    }
                }
            }
            return true
        }

        // ----- 商品明细行 start ---
        function getGoodsInfoTax(goods, invoiceType) {
            const rateReq = {
                taxMergeCode: goods.taxMergeCode,
                invType: invoiceType,
                privilegeType: encodeURIComponent(goods.privilegeType),
            }
            return httpRequest.get_queryGoodsTax(rateReq).then((res) => res.data.value)
        }
        // 选中商品行
        $scope.qryTaxClassInfo = function qryTaxClassInfo($item, goods) {
            goods.fromGoods($item)
            goods.isTax = $scope.invoice.isTax
            getGoodsInfoTax($item, $scope.invoice.invType).then((reteArr) => {
                const zeroTaxArr = $scope.dictionary.zero_tax
                for (let i = 0, l = zeroTaxArr.length; i < l; i++) {
                    if (zeroTaxArr[i].enumName === $item.privilegeType && reteArr[0].taxRate === 0) {
                        goods.zeroTax = zeroTaxArr[i].enumCode
                    }
                }
                goods.taxRateArr = reteArr
                goods.taxRateLoaded = true
                $scope.getAmount()
            })
        }
        const rep = /[\.]/
        // 数量 和 单价 整体位数16位（不包含小数点），小数位最多13位，整数位最多13位
        function isQuantitySetable(quantity) {
            if (!/^(-)?(\d|([1-9]\d+))(\.\d+)?$/.test(quantity)) {
                return false
            }
            if (quantity && quantity.toString().length > 17) {
                logger.logError('整体位数得不超过16位')
                return false
            }
            if (!rep.test(quantity) && quantity.toString().length > 13) {
                logger.logError('整数位最多13位')
                return false
            }
            return true
        }
        function isPriceSetable(price) {
            if (!/^(-)?(\d|([1-9]\d+))(\.\d+)?$/.test(price)) {
                return false
            }
            if (price && price.toString().length > 17) {
                logger.logError('整体位数得不超过16位')
                return false
            }
            if (!rep.test(price) && price.toString().length > 13) {
                logger.logError('整数位最多13位')
                return false
            }
            return true
        }
        // 金额 和 税额 整体位数16位（不包含小数点），小数点后保留2位
        function isAmountSetable(amount) {
            if (amount && Number(amount).toString().length > 16 && !rep.test(Number(amount))) {
                logger.logError('整体位数得不超过16位')
                return false
            }
            if (amount && amount.toString().length > 17 && rep.test(Number(amount))) {
                logger.logError('整数位最多16位')
                return false
            }
            return true
        }
        function quantityFormat(quantity) {}
        function calculateTax(amt, taxrate, isTax) {
            let taxamount = 0
            if (isTax === '1') {
                // 含税
                //taxamount = parseFloat(amt * taxrate / (1 + parseFloat(taxrate))).toFixed(2)
                taxamount = parseFloat(globalFn.Div(globalFn.Mul(amt, taxrate), globalFn.Add(1, taxrate))).toFixed(2)
                if (taxrate == '0.015') {
                    //taxamount = parseFloat(amt / 1.05 * 0.015).toFixed(2)
                    taxamount = parseFloat(globalFn.Mul(globalFn.Div(amt, 1.05), 0.015)).toFixed(2)
                }
            } else {
                // 不含税
                //taxamount = parseFloat(amt * taxrate).toFixed(2)
                taxamount = parseFloat(globalFn.Mul(amt, taxrate)).toFixed(2)
                if (taxrate == '0.015') {
                    //taxamount = parseFloat(amt * 0.015 / 1.035).toFixed(2)
                    taxamount = parseFloat(globalFn.Div(globalFn.Mul(amt, 0.015), 1.035)).toFixed(2)
                }
            }
            return taxamount
        }
        // 计算逻辑
        $scope.changeData = (obj, attr, index) => {
            const typeChange = {
                // 数量
                quantity: function () {
                    if (!isQuantitySetable(obj.quantity)) {
                        obj.quantity = ''
                        return
                    }
                    if (!obj.taxRate && obj.taxRate !== 0) {
                        return
                    }
                    // 有单价 计算金额 ，有金额 计算单价 默认含税标志为不含税，没有差额计算
                    if (obj.price) {
                        if ($scope.invoice.isTax == 1) {
                            obj.adValoremTotal = parseFloat(globalFn.Mul(obj.quantity, obj.taxPrice)).toFixed(2)
                            obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.adValoremTotal, obj.taxRate, $scope.invoice.isTax))
                            obj.amount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.taxAmount)).toFixed(2)
                            obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                            let noToFixedTaxAmount = globalFn.Mul(obj.quantity, obj.taxPrice)
                            obj.errorTaxNumber = globalFn.Sub(noToFixedTaxAmount, obj.adValoremTotal) //含税误差
                            let noToFixedAmount = globalFn.Mul(obj.quantity, obj.price)
                            obj.errorNumber = globalFn.Sub(noToFixedAmount, obj.amount) //不含税误差
                        } else {
                            obj.amount = parseFloat(globalFn.Mul(obj.quantity, obj.price)).toFixed(2)
                            obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                            obj.adValoremTotal = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                            obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8) * 1
                            obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                            let noToFixedTaxAmount = globalFn.Mul(obj.quantity, obj.taxPrice)
                            obj.errorTaxNumber = globalFn.Sub(noToFixedTaxAmount, obj.adValoremTotal) //含税误差
                            let noToFixedAmount = globalFn.Mul(obj.quantity, obj.price)
                            obj.errorNumber = globalFn.Sub(noToFixedAmount, obj.amount) //不含税误差
                        }
                    } else if (Number(obj.amount) != 0 && obj.quantity != 0 && obj.quantity) {
                        // 没有单价有金额 反算单价
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8) * 1
                        // obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                        obj.adValoremTotal = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8) * 1
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else {
                        obj.adValoremTotal = parseFloat(globalFn.Mul(obj.taxPrice, obj.quantity)).toFixed(2)
                        obj.amount = parseFloat(obj.adValoremTotal / (1 + parseFloat(obj.taxRate))).toFixed(2)
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8) * 1
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    }
                    $scope.getAmount()
                },
                //不含税单价
                price: function () {
                    if (!isPriceSetable(obj.price)) {
                        obj.price = ''
                        obj.taxPrice = ''
                        return
                    }
                    if (!obj.taxRate && obj.taxRate !== 0) {
                        return
                    }
                    // 有数量就算不含税金额、价税合计
                    if (obj.quantity) {
                        obj.amount = globalFn.Mul(obj.quantity, obj.price).toFixed(2)
                        obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                        obj.adValoremTotal = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else if (obj.amount && obj.price != 0 && obj.price) {
                        // 有不含税金额没有数量，反算数量，税额
                        obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.price), 8)
                        obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                        obj.adValoremTotal = parseFloat(globalFn.Add(obj.amount, obj.taxAmount)).toFixed(2)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else {
                        if (obj.price === '' || obj.price === null) {
                            obj.taxPrice = obj.price
                        } else {
                            obj.taxPrice = globalFn.cutOutPnumber(globalFn.Mul(obj.price, globalFn.Add(1, obj.taxRate)), 8)
                        }
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    }
                    $scope.getAmount()
                },
                //含税单价
                taxPrice: function () {
                    if (!isPriceSetable(obj.taxPrice)) {
                        obj.taxPrice = ''
                        obj.price = ''
                        return
                    }
                    // 有数量就算不含税金额、价税合计
                    if (obj.quantity) {
                        obj.adValoremTotal = globalFn.Mul(obj.quantity, obj.taxPrice).toFixed(2)
                        obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.adValoremTotal, obj.taxRate, $scope.invoice.isTax))
                        obj.amount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.taxAmount)).toFixed(2)
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else if (obj.adValoremTotal && obj.taxPrice != 0 && obj.taxPrice) {
                        // 有价税合计 没有数量 反算数量
                        obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.taxPrice), 8)
                        obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.adValoremTotal, obj.taxRate, $scope.invoice.isTax))
                        obj.amount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.taxAmount)).toFixed(2)
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else {
                        if (obj.taxPrice === '' || obj.taxPrice === null) {
                            obj.price = obj.taxPrice
                        } else {
                            obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.taxPrice, globalFn.Add(1, obj.taxRate)), 8)
                        }
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    }
                    $scope.getAmount()
                },
                //不含税金额
                amount: function () {
                    if (!isAmountSetable(obj.amount)) {
                        obj.amount = ''
                        obj.adValoremTotal = ''
                        return
                    }
                    if (!obj.taxRate && obj.taxRate !== 0) {
                        return
                    }
                    // 计算税额
                    obj.taxRate != 10.02 && (obj.taxAmount = calculateTax(obj.amount, obj.taxRate, $scope.invoice.isTax))
                    // 价税合计
                    obj.adValoremTotal = globalFn.Add(obj.amount, obj.taxAmount)
                    // 没有数量有单价 反算数量
                    if (obj.price && obj.price != 0 && !obj.quantity) {
                        obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.price), 8)
                        // 没有单价有数量 反算单价
                    } else if (obj.quantity && obj.quantity != 0 && !obj.taxPrice) {
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                        // 有数量 也有 单价 反算单价
                    } else if (obj.quantity && obj.quantity != 0 && obj.taxPrice) {
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                    }
                    obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    let noToFixedTaxAmount = globalFn.Mul(obj.quantity, obj.taxPrice)
                    obj.errorTaxNumber = globalFn.Sub(noToFixedTaxAmount, obj.adValoremTotal) //含税误差

                    let noToFixedAmount = globalFn.Mul(obj.quantity, obj.price)
                    obj.errorNumber = globalFn.Sub(noToFixedAmount, obj.amount) //不含税误差
                    $scope.getAmount()
                },
                //含税金额
                adValoremTotal: function () {
                    if (!isAmountSetable(obj.adValoremTotal)) {
                        obj.adValoremTotal = ''
                        obj.amount = ''
                        return
                    }
                    // 没有数量有单价 反算数量
                    if (obj.taxPrice && obj.taxPrice != 0 && !obj.quantity) {
                        obj.quantity = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.taxPrice), 8)
                        obj.amount = parseFloat(obj.adValoremTotal / (1 + parseFloat(obj.taxRate))).toFixed(2)
                        obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                        // 有数量没有单价 反算单价
                    } else if (obj.quantity && obj.quantity != 0 && !obj.taxPrice) {
                        obj.amount = parseFloat(obj.adValoremTotal / (1 + parseFloat(obj.taxRate))).toFixed(2)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                        if (obj.taxPrice === Infinity) {
                            obj.taxPrice = ''
                        } else {
                            obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        }
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                        // 有数量 也有 单价 反算 单价
                    } else if (obj.quantity && obj.quantity != 0 && obj.taxPrice) {
                        obj.amount = parseFloat(obj.adValoremTotal / (1 + parseFloat(obj.taxRate))).toFixed(2)
                        obj.taxPrice = globalFn.cutOutPnumber(globalFn.Div(obj.adValoremTotal, obj.quantity), 8)
                        if (obj.taxPrice === Infinity) {
                            obj.taxPrice = ''
                        } else {
                            obj.price = globalFn.cutOutPnumber(globalFn.Div(obj.amount, obj.quantity), 8)
                        }
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    } else if (!obj.taxPrice && !obj.quantity) {
                        // 没有单价 并且 没有数量
                        obj.amount = parseFloat(obj.adValoremTotal / (1 + parseFloat(obj.taxRate))).toFixed(2)
                        obj.taxAmount = parseFloat(globalFn.Sub(obj.adValoremTotal, obj.amount)).toFixed(2)
                    }
                    let noToFixedTaxAmount = globalFn.Mul(obj.quantity, obj.taxPrice)
                    obj.errorTaxNumber = globalFn.Sub(noToFixedTaxAmount, obj.adValoremTotal) //含税误差

                    let noToFixedAmount = globalFn.Mul(obj.quantity, obj.price)
                    obj.errorNumber = globalFn.Sub(noToFixedAmount, obj.amount) //不含税误差
                    $scope.getAmount()
                },
                taxRate: function () {},
            }
            typeChange[attr]()
        }

        // 校验税额是否超过 正负0.06
        $scope.getTaxAmount = function (item) {
            let realTaxAmount = item.amount * item.taxRate //税额
            if (Math.abs(globalFn.Sub(item.taxAmount, realTaxAmount)) > 0.06) {
                item.taxAmount = (item.amount * item.taxRate).toFixed(2) //税额 保留两位小数
                item.adValoremTotal = globalFn.Add(item.amount, item.taxAmount)
                item.taxPrice = globalFn.cutOutPnumber(globalFn.Div(item.adValoremTotal, item.quantity), 15)
            } else {
                item.adValoremTotal = globalFn.Add(item.amount, item.taxAmount)
                item.taxPrice = globalFn.cutOutPnumber(globalFn.Div(item.adValoremTotal, item.quantity), 15)
            }
            $scope.getAmount()
        }
        $scope.commonScroll = function commonScroll() {
            document.activeElement.blur()
            $scope.getAmount()
        }
        $scope.onScrollDown = function () {
            if ($scope.invoice.min + $scope.invoice.step < $scope.invoice.details.length && $scope.invoice.max < $scope.invoice.details.length) {
                $scope.invoice.min += $scope.invoice.step
                $scope.invoice.max += $scope.invoice.step
                if ($scope.invoice.details.length - $scope.invoice.max < 11) {
                    $scope.invoice.max = $scope.invoice.details.length
                }
                const msg = `正在加载${$scope.invoice.min + 2}-${$scope.invoice.max}条商品明细,共${$scope.invoice.details.length}条`
                utils.loading(msg)
                $scope.getAmount()
                $scope.$apply()
                setTimeout(() => {
                    $('.slimScrollBar').css({
                        top: 0.5,
                    })
                    utils.loaded()
                }, 800)
            }
        }
        $scope.onScrollTop = function () {
            if ($scope.invoice.min - $scope.invoice.step > -2) {
                $scope.invoice.min -= $scope.invoice.step
                $scope.invoice.max = $scope.invoice.min + $scope.invoice.step + 1
                if ($scope.invoice.details.length - $scope.invoice.max < 11) {
                    $scope.invoice.max = $scope.invoice.details.length
                }
                const msg = `正在加载${$scope.invoice.min + 2}-${$scope.invoice.max}条商品明细,共${$scope.invoice.details.length}条`
                utils.loading(msg)
                $scope.getAmount()
                $scope.$apply()
                setTimeout(() => {
                    $('.slimScrollBar').css({
                        top: 0.5,
                    })
                    utils.loaded()
                }, 800)
            }
        }
        $scope.getAmount = function getAmount() {
            let totalAmt = 0
            let totalTaxamt = 0
            for (let key = 0, len = $scope.invoice.details.length; key < len; key++) {
                const item = $scope.invoice.details[key]
                item.amount = globalFn.Sub(item.adValoremTotal, item.taxAmount)
                totalAmt = globalFn.Add(totalAmt, item.amount)
                totalTaxamt = globalFn.Add(totalTaxamt, item.taxAmount)
            }
            $scope.invoice.totalAmt = totalAmt
            $scope.invoice.adValoremTotal = parseFloat(globalFn.Add(totalTaxamt, totalAmt)).toFixed(2)
            $scope.invoice.totalTaxamt = totalTaxamt
        }
        $scope.taxChange = function () {
            $scope.getAmount()
        }
        $scope.$watch('invoice.details.length', () => {
            $scope.getAmount()
        })
        $scope.$watch('invoice.isTax', () => {
            $scope.getAmount()
        })
        // 大量使用get，set影响性能，合计计算使用getAmount，差额导致金额税额修改不会触发，但是会触发remark get
        $scope.$watch('invoice.remark', () => {
            $scope.getAmount()
        })
        $scope.qryUnitNameList = function qryUnitNameList($item) {
            return $http.get(`${host.etcloudOvat}tax4/ovatTax4InvoiceUnit/queryUnitList?unitName=${$item}`).then((response) =>
                response.data.value.map((item) =>
                    $.extend(
                        {},
                        {
                            unit: `${item.unitName}`,
                        },
                        item
                    )
                )
            )
        }
        // ----- 商品明细行 end ---
        // 省市区弹窗
        $scope.openModel = function (billInfo, type) {
            $uibModal
                .open({
                    templateUrl: 'provinceModCtrl.html',
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        function ctrl(scope, uibModalInstance, logger) {
                            if (type && type === 'q') {
                                scope.param = {
                                    provinceInfo: billInfo.provinceInfo_q,
                                    cityInfo: billInfo.cityInfo_q,
                                    areaInfo: billInfo.areaInfo_q,
                                }
                            } else if (type && type === 'z') {
                                scope.param = {
                                    provinceInfo: billInfo.provinceInfo_z,
                                    cityInfo: billInfo.cityInfo_z,
                                    areaInfo: billInfo.areaInfo_z,
                                }
                            } else {
                                scope.param = {
                                    provinceInfo: billInfo.provinceInfo,
                                    cityInfo: billInfo.cityInfo,
                                    areaInfo: billInfo.areaInfo,
                                }
                            }

                            scope.provinceData = config.provinceData
                            if (scope.param.cityInfo) {
                                const data = scope.provinceData.filter((item) => item.name === scope.param.provinceInfo)
                                scope.cityData = data[0].cityList
                            }
                            if (scope.param.areaInfo) {
                                const data = scope.cityData.filter((item) => item.name === scope.param.cityInfo)
                                scope.areaData = data[0].areaList
                            }
                            scope.sfChange = function () {
                                const data = scope.provinceData.filter((item) => item.name === scope.param.provinceInfo)
                                scope.cityData = data[0] ? data[0].cityList : []
                            }
                            scope.csChange = function () {
                                const data = scope.cityData.filter((item) => item.name === scope.param.cityInfo)
                                scope.areaData = data[0] ? data[0].areaList : []
                            }
                            scope.cancel = function cancel() {
                                uibModalInstance.close()
                            }
                            scope.ok = function ok() {
                                if (!scope.param.provinceInfo) {
                                    logger.logError('省 必填!')
                                    return
                                }
                                if (!scope.param.cityInfo) {
                                    logger.logError('市 必填!')
                                    return
                                }
                                if (!scope.param.areaInfo) {
                                    logger.logError('区 必填!')
                                    return
                                }
                                uibModalInstance.close(scope.param)
                            }
                        },
                    ],
                    openedClass: 'mod-modal mod-modal-xs',
                    backdrop: 'static',
                })
                .result.then((result) => {
                    if (result) {
                        console.log(type)
                        console.log(billInfo)
                        if (type && type === 'q') {
                            billInfo.provinceInfo_q = result.provinceInfo
                            billInfo.cityInfo_q = result.cityInfo
                            billInfo.areaInfo_q = result.areaInfo
                            billInfo.placeOfOrigin = `${result.provinceInfo}${result.cityInfo}${result.areaInfo}`
                        } else if (type && type === 'z') {
                            billInfo.provinceInfo_z = result.provinceInfo
                            billInfo.cityInfo_z = result.cityInfo
                            billInfo.areaInfo_z = result.areaInfo
                            billInfo.placeOfDestination = `${result.provinceInfo}${result.cityInfo}${result.areaInfo}`
                        } else {
                            $scope.invoice.extend.provinceInfo = result.provinceInfo
                            $scope.invoice.extend.cityInfo = result.cityInfo
                            $scope.invoice.extend.areaInfo = result.areaInfo
                            if ($scope.invoice.extend.specificElements == '06') {
                                // 不动产租赁服务
                                $scope.invoice.extend.administrativeRegion = result.provinceInfo + result.cityInfo + result.areaInfo
                            }
                            if ($scope.invoice.extend.specificElements == '03') {
                                // 建筑服务
                                $scope.invoice.extend.site = result.provinceInfo + result.cityInfo + result.areaInfo
                            }
                        }
                    }
                })
        }
        // 格式化 特定业务数据 展示
        function formatSpecificData() {
            $scope.invoice.customer.invType = $scope.invoice.invType
            $scope.invoice.sale.invType = $scope.invoice.invType
            if ($scope.invoice.extend.specificElements == '06') {
                // 不动产租赁服务
                //房屋产权证书/不动产权证号 certificateOfTitle
                //面积单位 unitOfArea
                //不动产地址 administrativeRegion + fullAddress
                //租赁期起止 leaseTermStart leaseTermEnd
                //跨地（市）标志 transRegionalFlag
                let realEstateSpecific = JSON.parse($scope.invoice.extend.realEstateSpecific)
                if (realEstateSpecific) {
                    $scope.invoice.extend.certificateOfTitle = realEstateSpecific.certificateOfTitle
                    $scope.invoice.extend.unitOfArea = realEstateSpecific.unitOfArea
                    $scope.invoice.extend.administrativeRegion = realEstateSpecific.administrativeRegion
                    $scope.invoice.extend.fullAddress = realEstateSpecific.fullAddress
                    $scope.invoice.extend.leaseTermStart = realEstateSpecific.leaseTermStart
                    $scope.invoice.extend.leaseTermEnd = realEstateSpecific.leaseTermEnd
                    $scope.invoice.extend.transRegionalFlag = realEstateSpecific.transRegionalFlag
                }
            }
            if ($scope.invoice.extend.specificElements == '03') {
                // 建筑服务
                // 建筑服务发生地 site
                // 发生地详细地址 siteDetailedAddress
                // 建筑项目名称 constructionProjectName
                // 土地增值税项目编号 landItemNumber
                // 跨地（市）标志  transRegionalFlag N：否；Y：是
                let realEstateSpecific = JSON.parse($scope.invoice.extend.realEstateSpecific)
                if (realEstateSpecific) {
                    $scope.invoice.extend.landItemNumber = realEstateSpecific.landItemNumber
                    $scope.invoice.extend.site = realEstateSpecific.site
                    $scope.invoice.extend.siteDetailedAddress = realEstateSpecific.siteDetailedAddress
                    $scope.invoice.extend.constructionProjectName = realEstateSpecific.constructionProjectName
                    $scope.invoice.extend.transRegionalFlag = realEstateSpecific.transRegionalFlag
                }
            }
        }
        // 格式化 特定业务数据 提交
        function submitFormatSpecificData() {
            if ($scope.invoice.extend.specificElements == '06') {
                // 不动产租赁服务
                //房屋产权证书/不动产权证号 certificateOfTitle
                //面积单位 unitOfArea
                //不动产地址 administrativeRegion + fullAddress
                //租赁期起止 leaseTermStart leaseTermEnd
                //跨地（市）标志 transRegionalFlag
                let realEstateSpecific = {
                    leaseTermStart: $scope.invoice.extend.leaseTermStart,
                    leaseTermEnd: $scope.invoice.extend.leaseTermEnd,
                    transRegionalFlag: $scope.invoice.extend.transRegionalFlag,
                    fullAddress: $scope.invoice.extend.fullAddress,
                    certificateOfTitle: $scope.invoice.extend.certificateOfTitle,
                    unitOfArea: $scope.invoice.extend.unitOfArea,
                    administrativeRegion: $scope.invoice.extend.administrativeRegion,
                }
                $scope.invoice.extend.realEstateSpecific = JSON.stringify(realEstateSpecific)
                //<不动产经营租赁服务>时：商品明细区：规格型号、单位改为不可编辑，提交时内容清空
                $scope.invoice.details.forEach((i) => {
                    i.spec = ''
                    i.unit = ''
                })
            }
            //特定发票 详情页面展示值改造
            if ($scope.invoice.extend.specificElements == '03') {
                // 建筑服务
                // 建筑服务发生地 site
                // 发生地详细地址 siteDetailedAddress
                // 建筑项目名称 constructionProjectName
                // 土地增值税项目编号 landItemNumber
                // 跨地（市）标志  transRegionalFlag N：否；Y：是
                let realEstateSpecific = {
                    transRegionalFlag: $scope.invoice.extend.transRegionalFlag,
                    site: $scope.invoice.extend.site,
                    constructionProjectName: $scope.invoice.extend.constructionProjectName,
                    siteDetailedAddress: $scope.invoice.extend.siteDetailedAddress,
                    landItemNumber: $scope.invoice.extend.landItemNumber,
                }
                $scope.invoice.extend.realEstateSpecific = JSON.stringify(realEstateSpecific)
                //<建筑服务>时：商品明细区：规格型号、单位、数量、单价字段改为不可编辑，提交时内容清空
                $scope.invoice.details.forEach((i) => {
                    i.spec = ''
                    i.unit = ''
                    i.quantity = ''
                    i.price = ''
                    i.taxPrice = ''
                })
            }
        }

        //运输服务发票特定要素

        $scope.ysSelectedAll = false
        // $scope.freightTransportDetailList = [
        //     {
        //         placeOfOrigin: '',
        //         placeOfDestination: '',
        //         transferType: '',
        //         transferToolLicensePlate: '',
        //         goodsName: '',
        //     },
        // ]

        $scope.addYsRow = function () {
            $scope.invoice.freightTransportDetailList.push({
                placeOfOrigin: '',
                placeOfDestination: '',
                transferType: '',
                transferToolLicensePlate: '',
                goodsName: '',
                ysSelected: false,
            })
            $scope.ysSelectedAll = false
        }
        $scope.delYsRow = function () {
            $scope.invoice.freightTransportDetailList = $scope.invoice.freightTransportDetailList.filter((ele) => {
                return !ele.ysSelected
            })
            if (!$scope.invoice.freightTransportDetailList.length) return ($scope.ysSelectedAll = false)
            $scope.ysSelectedAll = $scope.invoice.freightTransportDetailList.every((ele) => ele.ysSelected)
        }
        $scope.ysSelectedAllChange = function () {
            console.log($scope.ysSelectedAll)
            $scope.invoice.freightTransportDetailList.forEach((ele) => {
                ele.ysSelected = $scope.ysSelectedAll
            })
            console.log($scope.invoice.freightTransportDetailList)
        }
        $scope.ysItemChange = function (item) {
            $scope.ysSelectedAll = $scope.invoice.freightTransportDetailList.every((ele) => ele.ysSelected)
        }
        $scope.specificElementsChange = function () {
            if ($scope.invoice.extend.specificElements !== '04') {
                $scope.invoice.freightTransportDetailList = []
            }
        }
    }
}
fullElectricInvoiceEditCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', '$http', 'logger', 'buyerChecker', 'globalFn', '$uibModal']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/edit.js